import Vue from 'vue'
import VueRouter from 'vue-router'
const PrivacyAgreement=()=>import('../views/privacyAgreement')
const UsersAgreement=()=>import('../views/usersAgreement')
const SvipServiceAgreement=()=>import('../views/svipServiceAgreement')
const SvipContinuSubscribAgreement=()=>import('../views/svipContinuSubscribAgreement')
const childAgreement=()=>import('../views/childAgreement')
const Home=()=>import('../views/Home')
Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
    {
      path: '/usersAgreement',
      name: 'UsersAgreement',
      component: UsersAgreement
    },
    {
      path: '/privacyAgreement',
      name: 'PrivacyAgreement',
      component: PrivacyAgreement
    },
    {
      path: '/svipServiceAgreement',
      name: 'svipServiceAgreement',
      component: SvipServiceAgreement
    },
    {
      path: '/svipContinuSubscribAgreement',
      name: 'svipContinuSubscribAgreement',
      component: SvipContinuSubscribAgreement
    },
    {
      path: '/childAgreement',
      name: 'childAgreement',
      component: childAgreement
    }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
